
export default [
  {
    name:"Governance",
    path: '/Governance',
    component: () => import('@/views/governance/index'),
    meta: { title: 'Brief', noCache: false, affix: false},
    children:[
      {
        path: '',
        redirect:"pool"
      },
      {
        name:"pool",
        path: 'pool',
        component: () => import('@/views/governance/pool/index.vue'),
        meta: { title: 'Proposal pool', noCache: false, affix: false},
      },
      {
        name:"vote",
        path: 'vote',
        component: () => import('@/views/governance/vote/index.vue'),
        meta: { title: 'My vote', noCache: false, affix: false},
      },
      {
        name:"proposal",
        path: 'proposal',
        component: () => import('@/views/governance/proposal/index.vue'),
        meta: { title: 'My proposal', noCache: false, affix: false},
      },
    ]
  },
  {
    name:"voteDetail",
    path: 'vote/Detail',
    hidden:true,
    component: () => import('@/views/governance/pool/voteDetail.vue'),
    meta: { title: 'vote Detail', noCache: false, affix: false},
  },
  {
    name:"voteCreate",
    path: 'vote/create',
    hidden:true,
    component: () => import('@/views/governance/proposal/create.vue'),
    meta: { title: 'Vote Create', noCache: false, affix: false},
  },

]
